/** The set-aside list, loaded once and written through on every change. */
import { useCallback, useEffect, useState } from "react";

import { readAside, writeAside } from "@/store/aside";

const NONE: ReadonlySet<number> = new Set();

export interface Aside {
  ids: ReadonlySet<number>;
  toggle: (simklId: number) => void;
  /** Idempotent: watching an episode takes a show off the list, if it is on it. */
  clear: (simklId: number) => void;
}

export function useAside(): Aside {
  const [ids, setIds] = useState<ReadonlySet<number>>(NONE);

  useEffect(() => {
    void readAside().then((stored) => {
      setIds(new Set(stored));
    });
  }, []);

  const toggle = useCallback((simklId: number) => {
    setIds((current) => {
      const next = new Set(current);
      if (!next.delete(simklId)) next.add(simklId);
      void writeAside([...next]);
      return next;
    });
  }, []);

  const clear = useCallback((simklId: number) => {
    setIds((current) => {
      if (!current.has(simklId)) return current;
      const next = new Set(current);
      next.delete(simklId);
      void writeAside([...next]);
      return next;
    });
  }, []);

  return { ids, toggle, clear };
}
